var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1707478229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.79998 4L5.19995 8.80003V25.6001C5.19995 26.2367 5.45281 26.8471 5.9029 27.2972C6.35299 27.7473 6.96344 28.0002 7.59997 28.0002H24.4001C25.0366 28.0002 25.6471 27.7473 26.0971 27.2972C26.5472 26.8471 26.8001 26.2367 26.8001 25.6001V8.80003L23.2001 4H8.79998Z",
    stroke: "#555770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.19995 8.80078H26.8001",
    stroke: "#555770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.7999 13.5996C20.7999 14.8727 20.2942 16.0936 19.394 16.9937C18.4938 17.8939 17.2729 18.3996 15.9999 18.3996C14.7268 18.3996 13.5059 17.8939 12.6057 16.9937C11.7055 16.0936 11.1998 14.8727 11.1998 13.5996",
    stroke: "#555770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.707fadf0cf2a1643eb461cdbf37484bb.svg";
export { ForwardRef as ReactComponent };